module.exports = __webpack_public_path__ + "static/img/egg_b_15.df4a8d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/b/egg_b_15.png
// module id = S49D
// module chunks = 1